import { render } from "./TradePermit.vue?vue&type=template&id=ad1a9e14&scoped=true"
import script from "./TradePermit.vue?vue&type=script&lang=js"
export * from "./TradePermit.vue?vue&type=script&lang=js"

import "./TradePermit.vue?vue&type=style&index=0&id=ad1a9e14&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1a9e14"]])

export default __exports__